// 测评分类体系
export interface QuizCategory {
  id: string;
  name: string;
  description: string;
  icon: string;
  quizzes: QuizItem[];
}

export interface QuizItem {
  id: string;
  title: string;
  summary: string;
  difficulty: 'basic' | 'intermediate' | 'advanced';
  time: number; // 分钟
  articleId: string | null;
}

// 测评分类配置（基于实际存在且有题目的课程）
export const quizCategories: QuizCategory[] = [
  {
    id: 'performance',
    name: '绩效管理',
    description: 'AI时代的绩效体系重构：从KPI到OKR，从打分到审计',
    icon: 'Calculator',
    quizzes: [
      { id: 'course-ai-performance-auditor', title: 'AI绩效审计员：谁来审计算法', summary: 'AI打分成为绩效依据后，谁来审计算法的公平性？', difficulty: 'advanced', time: 8, articleId: 'art-223' },
      { id: 'course-ai-performance-talk', title: 'AI做的绩效面谈，员工能接受吗', summary: '绩效差的员工反而更容易接受AI，绩效好的反而排斥', difficulty: 'intermediate', time: 6, articleId: null },
      { id: 'course-kpi-realtime-transparent', title: 'KPI不会消失，只是变得更实时更透明', summary: '实时KPI让管理透明，但也让压力倍增', difficulty: 'intermediate', time: 5, articleId: null },
      { id: 'course-ai-realtime-feedback', title: 'AI让绩效反馈从年度变成实时', summary: '实时反馈的好处和坏处，你准备好了吗', difficulty: 'basic', time: 5, articleId: null },
      { id: 'course-management-goal-alignment', title: '管理的本质是目标对齐', summary: '工具在变，对齐目标的本质没有变', difficulty: 'intermediate', time: 5, articleId: null },
      { id: 'course-quality-control-responsibility', title: '简单质检被AI取代后', summary: '当AI能做基础质检，人的价值在哪里', difficulty: 'advanced', time: 7, articleId: null },
    ]
  },
  {
    id: 'recruitment',
    name: '招聘面试',
    description: 'AI面试官来了：算法筛选、偏见识别、人机协作',
    icon: 'Users',
    quizzes: [
      { id: 'course-ai-employer-branding', title: 'AI做雇主品牌传播', summary: '让招聘从被动等简历到主动吸引人才', difficulty: 'intermediate', time: 6, articleId: null },
      { id: 'course-hr-value-ai', title: '会议纪要都能自动写了，HR还剩什么', summary: 'AI时代HR的价值重塑', difficulty: 'intermediate', time: 6, articleId: null },
      { id: 'course-resume-screening-human-intuition', title: '简历初筛自动化', summary: 'AI筛简历效率高，但人的直觉还有用吗', difficulty: 'basic', time: 5, articleId: null },
    ]
  },
  {
    id: 'training',
    name: '培训学习',
    description: '从集中培训到即时学习：AI让学习成为工作的伴随',
    icon: 'GraduationCap',
    quizzes: [
      { id: 'course-ai-trainer-tech-iteration', title: 'AI培训师如何应对技术快速迭代', summary: '技术迭代太快，培训内容追不上怎么办', difficulty: 'advanced', time: 7, articleId: null },
      { id: 'course-ai-trainer-transition', title: '从传统培训师到AI培训师', summary: '转型不是学工具，是换脑子', difficulty: 'intermediate', time: 7, articleId: null },
      { id: 'course-ai-knowledge-extraction', title: '用AI做知识萃取', summary: '让老员工脑子里的经验变成组织的数字资产', difficulty: 'intermediate', time: 6, articleId: null },
      { id: 'course-jit-learning', title: 'AI让学习随时发生', summary: '即时学习 vs 集中培训，哪个更有效', difficulty: 'basic', time: 5, articleId: null },
      { id: 'course-personalized-learning', title: '学习路径个性化', summary: 'AI为每个员工定制学习路径', difficulty: 'intermediate', time: 6, articleId: null },
      { id: 'course-knowledge-mgmt-qa', title: '知识管理从文档库到智能问答', summary: 'AI驱动的知识库让信息获取效率翻倍', difficulty: 'intermediate', time: 6, articleId: null },
    ]
  },
  {
    id: 'meeting',
    name: '会议效率',
    description: 'AI让会议从开完就忘变成持续沉淀：纪要、追踪、复盘',
    icon: 'MessageSquare',
    quizzes: [
      { id: 'course-ai-meeting-review', title: 'AI会议复盘：让每次会议都有沉淀', summary: '纪要自动生成，Action Item自动追踪', difficulty: 'basic', time: 5, articleId: null },
      { id: 'course-weekly-meeting', title: '你的周会，为什么越开越累', summary: '每周例会变成走过场，AI能拯救它吗', difficulty: 'basic', time: 5, articleId: null },
      { id: 'course-ai-interpretation', title: '跨国会议还要配同声传译？', summary: '语言信息差消除了，文化信息差还在', difficulty: 'intermediate', time: 6, articleId: null },
    ]
  },
  {
    id: 'team',
    name: '团队管理',
    description: 'AI时代的团队凝聚力、文化重塑、冲突调解',
    icon: 'Heart',
    quizzes: [
      { id: 'course-ai-middle-manager-disappear', title: 'AI让中层传话筒角色消失', summary: '中层管理者需要重新定义自己的价值', difficulty: 'advanced', time: 8, articleId: null },
      { id: 'course-ai-psychological-safety', title: 'AI时代的心理安全感', summary: '当AI监控无处不在，团队还能有安全感吗', difficulty: 'intermediate', time: 6, articleId: null },
      { id: 'course-conflict-resolution-ai', title: '跨部门冲突调解', summary: 'AI能调解冲突，但人和人之间的信任才是关键', difficulty: 'intermediate', time: 6, articleId: null },
      { id: 'course-negative-feedback-ai', title: 'AI能做负面反馈吗', summary: '负面反馈的艺术，AI能学会吗', difficulty: 'advanced', time: 7, articleId: null },
    ]
  },
  {
    id: 'data',
    name: '数据与安全',
    description: 'AI审计、数据治理、隐私保护、组织信任',
    icon: 'Shield',
    quizzes: [
      { id: 'course-data-governance', title: '数据治理：从数据资产到组织记忆', summary: '数据不只是资产，更是组织的集体记忆', difficulty: 'advanced', time: 8, articleId: null },
      { id: 'course-data-privacy', title: '数据隐私与组织信任', summary: 'AI需要数据，员工需要隐私，管理者两难', difficulty: 'intermediate', time: 7, articleId: null },
      { id: 'course-translation-quality-guardian', title: '翻译质量谁来把关', summary: 'AI翻译质量虽高，但业务风险谁来承担', difficulty: 'intermediate', time: 6, articleId: null },
    ]
  },
  {
    id: 'strategy',
    name: '战略决策',
    description: 'AI能预测但不能选择：决策的最后一公里',
    icon: 'Target',
    quizzes: [
      { id: 'course-ai-gray-zone-decision', title: 'AI如何改变灰色地带决策', summary: '道德困境和灰色地带，AI无法替你做决定', difficulty: 'advanced', time: 8, articleId: null },
      { id: 'course-ai-kpi-performance-management', title: '算法驱动的绩效管理', summary: '当KPI由AI设定，管理者的角色如何转变', difficulty: 'intermediate', time: 7, articleId: null },
      { id: 'course-ai-data-ownership-dispute', title: '个人数据所有权的新争端', summary: '当AI比你更懂你，你的数据属于谁', difficulty: 'advanced', time: 8, articleId: null },
    ]
  },
];

// 获取所有测评总数
export function getTotalQuizCount(): number {
  return quizCategories.reduce((sum, cat) => sum + cat.quizzes.length, 0);
}

// 获取测评分类统计
export function getQuizStats(): { basic: number; intermediate: number; advanced: number } {
  const stats = { basic: 0, intermediate: 0, advanced: 0 };
  quizCategories.forEach(cat => {
    cat.quizzes.forEach(q => {
      stats[q.difficulty]++;
    });
  });
  return stats;
}
